// polyfill
import 'babel-polyfill'
// Vue
import Vue from 'vue'
import App from './App'
// store
import store from '@/store/index'
// 模拟数据
// import '@/mock'
// 多国语
import i18n from './i18n'
// 核心插件
import d2Admin from '@/plugin/d2admin'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import D2Crud from '@d2-projects/d2-crud'
import pluginExport from '@d2-projects/vue-table-export'
import pluginImport from '@d2-projects/vue-table-import'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

// 菜单和路由设置
import router from './router'
// import menuHeader from '@/menu/header'
// import menuAside from '@/menu/aside'
import { frameInRoutes } from '@/router/routes'
import { GetMenu } from '@api/common'
import util from '@/libs/util'
// 大屏展示的组件
import dataV from '@jiaminghi/data-view'

// 核心插件
Vue.use(d2Admin)
// d2-crud
Vue.use(ElementUI)
Vue.use(D2Crud)
// 表格导入导出
Vue.use(pluginExport)
Vue.use(pluginImport)

Vue.use(preview)

Vue.use(dataV)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      GetMenu().then(res => {
        // 处理路由 得到每一级的路由设置
        this.$store.commit('d2admin/page/init', frameInRoutes)
        // 设置顶栏菜单
        this.$store.commit('d2admin/menu/headerSet', res.menuList)
        // 初始化菜单搜索功能
        this.$store.commit('d2admin/search/init', res.menuList)
        // 设置侧边栏菜单
        this.$store.commit('d2admin/menu/asideSet', res.menuList)
      })
    }
  },
  mounted () {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  }
}).$mount('#app')
